var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/tag.cfe93db0.png","uri@2x": __webpack_public_path__ + "static/media/tag.42c01c34.png","uri@3x": __webpack_public_path__ + "static/media/tag.fbaf73de.png",
    width: 106,
    height: 18
});